export default __webpack_public_path__ + "3aaa21e86c49f6ec255245feebc350ff.svg";